import { capitalize } from "../../helpers/string/capitalize";

export type NotificationType = "Info" | "Error" | "Warning" | "Success";

const notificationTypeTitles: Record<NotificationType, string> = {
  Info: "Information",
  Error: "Error",
  Warning: "Warning",
  Success: "Success",
};

const NOTIFICATION_BOX_STYLE = "flex rounded-lg p-2";
export const notificationTypeStyle: Record<NotificationType, string> = {
  Info: `bg-stone-500 ${NOTIFICATION_BOX_STYLE}`,
  Error: `bg-red-500 ${NOTIFICATION_BOX_STYLE}`,
  Warning: `bg-amber-500 ${NOTIFICATION_BOX_STYLE}`,
  Success: `bg-green-500 ${NOTIFICATION_BOX_STYLE}`,
};

export const getNotificationTypeTitle = (
  notificationType: NotificationType,
): string => notificationTypeTitles[notificationType];

export type ResponseMessageData =
  | string
  | { successMessage: string; errorMessage: string };

export type Notify = (type: NotificationType, text: string) => void;

export const responseNotification = (
  notify: Notify,
  requestSuccess: boolean,
  messageData: ResponseMessageData,
) => {
  if (requestSuccess) {
    notify(
      "Success",
      typeof messageData === "string"
        ? `${capitalize(messageData)} changed`
        : messageData.successMessage,
    );
    return true;
  } else {
    notify(
      "Error",
      typeof messageData === "string"
        ? `Could not change ${messageData}`
        : messageData?.errorMessage,
    );
    return false;
  }
};
